import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getChatApiBaseUrl } from '../../utils/getChatApiBaseUrl';
import { getBrand } from '../../utils/getBrand';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgentAssistService {
  constructor(private http: HttpClient) {}

  startAgentAssistSession(chatId: string, sessionId: string) {
    const date = new Date().toISOString();
    const headers = {
      'Chat-Id': chatId,
      'Dialog-Timestamp': date,
      'Client-App-Id': 'VA-ROGERS',
      'Client-Channel': 'web',
      Brand: getBrand().name.toUpperCase(),
      vaId: sessionId,
      'x-app-id': 'Rogers.com',
    };
    return this.http.post(
      getChatApiBaseUrl() + '/va/aa/session',
      {},
      { headers, withCredentials: true }
    );
  }

  sendAgentAssistMessage(
    text: string,
    chatId: string,
    sessionId: string,
    departmentId: string
  ) {
    const date = new Date().toISOString();
    const headers = {
      'Chat-Id': chatId,
      'Dialog-Timestamp': date,
      'Client-App-Id': 'VA-ROGERS',
      'Client-Channel': 'web',
      Brand: getBrand().name.toUpperCase(),
      vaId: sessionId,
      'x-app-id': 'Rogers.com',
      'department-id': departmentId,
    };
    return this.http.post(
      getChatApiBaseUrl() + '/va/aa/dialog',
      { dialog: text },
      { headers, withCredentials: true }
    );
  }

  getAgentAssistOperatorsIds(): Observable<string[]> {
    return this.http
      .get(`configurations/agent-assist/aaEligibleAgents.json`)
      .pipe(map((item: string[]) => item));
  }

  getAgentAssistDepartmentIds(): Observable<any[]> {
    return this.http
      .get(`configurations/agent-assist/aaEligibleDepartments.json`)
      .pipe(map((item: string[]) => item));
  }

  getDepartmentId(chatId: string): Observable<any> {
    const headers = {
      'chat-id': chatId,
      brand: getBrand().name.toUpperCase(),
    };
    return this.http
      .get(getChatApiBaseUrl() + '/va/livechat/chat', { headers })
      .pipe(map((item: any) => item));
  }
}
